import React, { memo } from 'react'
import { useTranslation } from 'react-i18next'

import translationKeys from '@translationKeys'
import { Nullable } from '@types'

import CustomPopover from '@components/CustomPopover'
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined'
import DialogContentText from '@mui/material/DialogContentText'
import Typography from '@mui/material/Typography'
import { colors, componentSizes } from '@theme/variables'

import {
  CloseIconWrapper,
  DialogContentHeader,
  ErrorDialogContentWrapper,
  MiddleSectionWrapper,
  StyledErrorBox,
} from './index.styles'

export interface ErrorPopupProps {
  title: string
  text: string
  onClose: () => void
  width?: number
  anchor: HTMLElement | null
  setAnchor: (event: Nullable<HTMLElement>) => void
}

const ErrorPopup = ({ title, text, onClose, width, anchor, setAnchor }: ErrorPopupProps) => {
  const { t } = useTranslation()

  return (
    <CustomPopover
      id="error-popup"
      data-testid="error-popup"
      anchor={anchor}
      setAnchor={setAnchor}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      sx={{
        padding: '20px',
        marginTop: '-16px',
        marginLeft: '10px',
      }}
    >
      <StyledErrorBox padding="0" width={width}>
        <ErrorDialogContentWrapper sx={{ padding: componentSizes.smDistance }}>
          <ErrorOutlineOutlinedIcon data-testid="error-popup-warn-icon" sx={{ color: colors.error }} />
          <MiddleSectionWrapper>
            <DialogContentHeader data-testid="error-popup-title">{title}</DialogContentHeader>
            <DialogContentText>
              <Typography variant="body1" sx={{ color: colors.bodyText }} data-testid="error-popup-body">
                {text}
              </Typography>
            </DialogContentText>
          </MiddleSectionWrapper>
          <CloseIconWrapper onClick={onClose} data-testid="error-popup-close-icon">
            {t(translationKeys.COMMON_CLOSE)}
            &nbsp;X
          </CloseIconWrapper>
        </ErrorDialogContentWrapper>
      </StyledErrorBox>
    </CustomPopover>
  )
}

export default memo(ErrorPopup)
